import { BaseModel } from '../../../models/base-model'
import { Question, AnswerChoice, TestExecution } from '../'

export class UserAnswer extends BaseModel {
  public question: Question
  public answerChoice: AnswerChoice
  public testExecution: TestExecution
  public value: string

  constructor() { super() }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/user-answer/user-answer.ts